"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = require("react");
var default_1 = __importDefault(require("../theme/default"));
var types_1 = require("../types");
var use_celo_1 = require("../use-celo");
var ModeState = /*#__PURE__*/function () {
  function ModeState() {
    _classCallCheck(this, ModeState);
    this._mode = types_1.Mode.Light;
    this.listeners = [];
  }
  _createClass(ModeState, [{
    key: "addEventListener",
    value: function addEventListener(listener) {
      this.listeners.push(listener);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(listener) {
      this.listeners = this.listeners.filter(function (x) {
        return x !== listener;
      });
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners() {
      this.listeners = [];
    }
  }, {
    key: "mode",
    set: function set(mode) {
      var _this = this;
      if (this._mode === mode) return;
      this._mode = mode;
      this.listeners.forEach(function (cb) {
        return cb(_this._mode);
      });
    },
    get: function get() {
      return this._mode;
    }
  }]);
  return ModeState;
}();
var state = new ModeState();
// const COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';
var DARK_CLASSES = ['dark', 'tw-dark'];
function hasDarkClasses(elem) {
  // const hasDarkMedia = window.matchMedia(COLOR_SCHEME_QUERY).matches;
  return DARK_CLASSES.some(function (cls) {
    return elem.classList.contains(cls);
  });
}
if (typeof MutationObserver !== 'undefined') {
  var body = document.getElementsByTagName('body');
  var html = document.getElementsByTagName('html');
  var elems = [].concat(_toConsumableArray(body), _toConsumableArray(html));
  var mutationCallback = function mutationCallback() {
    var isDark = elems.some(hasDarkClasses);
    state.mode = isDark ? types_1.Mode.Dark : types_1.Mode.Light;
  };
  var observer = new MutationObserver(mutationCallback);
  mutationCallback();
  elems.forEach(function (elem) {
    observer.observe(elem, {
      subtree: false,
      childList: false,
      attributeFilter: ['class']
    });
  });
}
function useTheme() {
  var _ref = (0, use_celo_1.useCeloInternal)(),
    theme = _ref.theme;
  var _ref2 = (0, react_1.useState)(state.mode),
    _ref3 = _slicedToArray(_ref2, 2),
    mode = _ref3[0],
    setMode = _ref3[1];
  (0, react_1.useEffect)(function () {
    var cb = function cb(m) {
      return setMode(m);
    };
    state.addEventListener(cb);
    return function () {
      state.removeEventListener(cb);
    };
  }, []);
  return theme || default_1.default[mode];
}
exports.default = useTheme;